import React from 'react';
import { Helmet } from 'react-helmet';
import Login from 'src/features/Login';

const LoginPage = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title> Login</title>
      </Helmet>
      <Login />
    </React.Fragment>
  );
};

export default LoginPage;
